(function () {
    'use strict';
    angular.module('app').controller('MessageQueeModalController', MessageQueeModalController);
    MessageQueeModalController.$inject=[
        '$uibModalInstance'
    ]

    function MessageQueeModalController(
        $uibModalInstance
    ){
        const vm = this;
        vm.message = "Your uploaded CSV for invoice shipments is now being queued for import. Kindly check the Unreconciled Shipments grid shortly to ensure all records are processed. Thank you!";

        vm.ok = closed;

        function closed(){
            $uibModalInstance.dismiss()
        }
    }

})()


// WEBPACK FOOTER //
// ./js/controllers/accounting/modals/MessageQueeModalController.js